import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

import { ShortcutIconName } from '../../../../common/ai.dictionary'
import { AiShortcutComponent, IconType, ShortcutConfig } from '../shortcut/shortcut.component'

export enum Shortcuts {
  SELECT = 'select',
  OPEN = 'open',
  EXIT = 'exit',
}

const shortcutsConfigMap: Record<Shortcuts, ShortcutConfig> = {
  [Shortcuts.SELECT]: {
    label: 'Select',
    icons: [
      { type: IconType.ICON, name: ShortcutIconName.ArrowUp },
      { type: IconType.ICON, name: ShortcutIconName.ArrowDown },
    ],
  },
  [Shortcuts.OPEN]: {
    label: 'Open',
    icons: [{ type: IconType.ICON, name: ShortcutIconName.ArrowCircDownLeft }],
  },
  [Shortcuts.EXIT]: { label: 'Exit', icons: [{ type: IconType.KEY, name: 'esc' }] },
}

@Component({
  selector: 'flx-ai-shortcuts',
  imports: [CommonModule, AiShortcutComponent],
  templateUrl: './shortcuts.component.html',
  styleUrls: ['./shortcuts.component.scss'],
})
export class AiShortcutsComponent {
  @Input() leftShortcuts: Shortcuts[]
  @Input() centerShortcuts: Shortcuts[]
  @Input() rightShortcuts: Shortcuts[]

  getShortcutConfig(shortcut: Shortcuts): ShortcutConfig {
    return shortcutsConfigMap[shortcut]
  }
}
